import YeuCauHoTro from "./yeu-cau-ho-tro/YeuCauHoTro";
import QuanLyNhanSu from "./quan-ly-nhan-su/QuanLyNhanSu";
import BaoCaoYCHT from "./bao-cao-yc-ho-tro/BaoCaoYCHT";
import BaoCaoThongKe from "./bao-cao-thong-ke/BaoCaoThongKe";

export const danhSachTabHTKT = () => [
  {
    eventKey: "0",
    title: "Yêu cầu hỗ trợ",
    component: <YeuCauHoTro/>,
  },
  {
    eventKey: "1",
    title: "Quản lý nhân sự",
    component: <QuanLyNhanSu />,
  },
  {
    eventKey: "2",
    title: "Báo cáo YC hỗ trợ",
    component: <BaoCaoYCHT />,
  },
  {
    eventKey: "3",
    title: "Báo cáo thống kê",
    component: <BaoCaoThongKe />,
  },
];
